const styles = (theme) => ({
	root: {
		maxWidth: 500,
		width: "345px",
		marginRight: "1rem",
		marginTop: "1rem",
	},
	media: {
		width: "345px",
		[theme.breakpoints.down("xs")]: {
			width: "17rem",
		},
		maxHeight: "240px",
		objectFit: "cover",
	},
	alert: {
		backgroundColor: "#3D4EAE",
	},
	formControl: {
		marginTop: theme.spacing(2),
		minWidth: 50,
	},
});

export default styles;
